import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * Validator to check for invalid external tags, or those that have been selectively
 * excluded from a particular field
 * @param max
 */
export function maxValidator(max: any): ValidatorFn {
    return (abstractControl: AbstractControl): ValidationErrors | null => {
        if (max) {
            if (abstractControl.value > max) {
                return {max: 'The value is greater than ' + max};
            } else {
                return null;
            }
        } else {
            return null;
        }
    };
}
